<template>
  <div class="flex min-h-screen flex-col">
    <div id="toast-wrapper" class="fixed z-50">
      <TheToast to="#toast-wrapper" />
    </div>

    <CookiesModal />

    <div class="flex flex-1 flex-col">
      <MinimalHeader :hidden="scrollState.isScrolledDown" />

      <div class="flex flex-1 flex-col">
        <slot />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useHead } from '#imports'

import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import TheToast from '@backmarket/nuxt-module-toast/TheToast.vue'
import CookiesModal from '@backmarket/nuxt-module-tracking/CookiesModal.vue'

import MinimalHeader from '@/scopes/navigation/components/MinimalHeader.vue'
import { useAppsflyer } from '~/scopes/appsflyer/composables/useAppsflyer'
import { useScrollState } from '~/scopes/customer-care/common/composables/useScrollState'

useHead({
  htmlAttrs: {
    lang: useI18nLocale(),
  },
})

const { scrollState } = useScrollState()
useAppsflyer()
</script>

<style>
/* Safari adds an Apple Smart Banner automatically because of the Universal links (See Doorman config: https://github.com/BackMarket/doorman/tree/77be9c7f8e2af4d0f0fc9fe1678ec8f39ac41c69/static/apple/universal-links)
   We want to hide it because we have our own custom Banner with Appsflyer
*/
[class*='apple-banner'] {
  display: none !important;
}
</style>
